import type { InputProps } from '@mui/material';

/**
 * Field type identifiers for the app-specific form field widgets that live
 * alongside this file (medicare number input, phone number, location input).
 * These predate `@montugroup/form-builder` and aren't part of its type system.
 */
export enum FormElements {
  input = 'input',
  number = 'number',
  list = 'list',
  email = 'email',
  select = 'select',
  signature = 'signature',
  phoneNumber = 'phoneNumber',
  medicareNumber = 'medicareNumber',
}

export type PhoneNumberType = {
  name: string;
  type: FormElements.phoneNumber;
  label?: string;
  countrySelect?: boolean;
  placeholder?: string;
  country?: string;
  defaultCountry?: string;
  requiredText?: string;
  invalidNumberText?: string;
  mustNotMatch?: [field: string, message: string];
  international?: boolean;
  autofill?: string;
  inputProps?: InputProps;
};

export type InputType = {
  name?: string;
  type:
    | FormElements.email
    | FormElements.number
    | FormElements.list
    | FormElements.input
    | FormElements.select
    | FormElements.signature
    | FormElements.medicareNumber;
  label: string;
  options?: string[];
  placeholder?: string;
  helperText?: string;
  required?: boolean;
  inputProps?: {
    size?: number;
    minlength?: number;
    maxlength?: number;
    min?: number;
    max?: number;
    format?: string;
  };
  autofill?: string;
};
